'use client';

import { twMerge } from 'tailwind-merge';

import { defaultDataTagGroup } from '@/constants/defaultSeo';
import { IMetaData } from '@lamesarv-sdk/types';
import { CustomComponentType, IComponentHeroService } from '@/types/cms';

import { FormType } from '../Form/types';
import { FormServiceAppointmentSteps } from '../Form/FormServiceAppointmentSteps';

import { HeroSlider } from './HeroSlider';

import { IDynamicsOptionSet } from '@/types/dynamicsForms';

export interface IHeroServiceProps extends IComponentHeroService {
  locationsOptionSet?: IDynamicsOptionSet;
  servicesOptionSet?: IDynamicsOptionSet;
  metadata?: IMetaData;
  successCallback?: () => void;
}

export const HeroService = ({
  classes,
  classes_container,
  metadata,
  locationsOptionSet,
  servicesOptionSet,
  data_tag,
  data_tag_group,
  slider_disable_pause_on_hover,
  slider_display_arrows,
  slider_display_dots,
  slider_images,
  slider_speed,
  classes_slider,
  ...formProps
}: IHeroServiceProps) => {
  return (
    <div
      className={twMerge('px-6 py-6 md:px-20 md:py-20 lg:py-24 bg-blue-50', classes)}
      data-tag={data_tag || 'heroService'}
      data-tag-group={data_tag_group || defaultDataTagGroup}
    >
      <div
        className={twMerge(
          'relative w-full flex flex-col lg:block gap-12 lg:container lg:mx-auto lg:min-h-[600px]',
          classes_container,
        )}
      >
        <div className="_lg:absolute _lg:top-1/2 _lg:left-0 _lg:-translate-y-1/2 lg:w-[500px]">
          <FormServiceAppointmentSteps
            {...formProps}
            componentType={CustomComponentType.form}
            type={FormType.serviceAppointmentSteps}
            locationsOptionSet={locationsOptionSet}
            servicesOptionSet={servicesOptionSet}
            metadata={metadata}
            data_tag={data_tag}
            data_tag_group={data_tag_group}
          />
        </div>
        <div className="lg:absolute lg:top-1/2 lg:left-[550px] lg:right-0 lg:-translate-y-1/2">
          <HeroSlider
            images={slider_images}
            speed={slider_speed}
            disable_pause_on_hover={slider_disable_pause_on_hover}
            display_arrows={slider_display_arrows}
            display_dots={slider_display_dots}
            classes={classes_slider}
            data_tag={data_tag}
            data_tag_group={data_tag_group}
          />
        </div>
      </div>
    </div>
  );
};
